import CalibrationType from 'src/views/Pages/Dashboard/Calibration/CalibrationType/CalibrationType.vue';
import CalibrationRange from 'src/views/Pages/Dashboard/Calibration/CalibrationRanges/CalibrationRange.vue';
import CalibrationCreateEdit from 'src/views/Pages/Dashboard/Calibration/CalibrationRanges/CalibrationCreateEdit.vue';
import CatchCalibration from 'src/views/Pages/Dashboard/Calibration/Create/CatchCalibration.vue';
import CalibrationReports from 'src/views/Pages/Dashboard/Calibration/Report/CalibrationReports.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';

const CalibrationRoutes = {
  path: 'calibration',
  name: 'calibration.calibration',
  component: MasterTab,
  props: { reference: 'calibrationTabs' },
  children: [
    {
      path: 'calibrationtypes',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'calibration.calibration',
          component: CalibrationType,
          meta: {
            prefix_permission: 'calibration_calibrationtypes',
          },
        },
      ],
    },
    {
      path: 'calibrationranges',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'calibration.calibration',
          component: CalibrationRange,
          meta: {
            prefix_permission: 'calibration_calibrationranges',
          },
        },
        {
          path: 'create',
          name: 'calibration.calibration',
          component: CalibrationCreateEdit,
          meta: {
            prefix_permission: 'calibration_calibrationranges',
          },
        },
        {
          path: 'edit',
          name: 'calibration.calibration',
          component: CalibrationCreateEdit,
          meta: {
            prefix_permission: 'calibration_calibrationranges',
          },
        },
      ],
    },
    {
      path: 'catchs',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'calibration.calibration',
          component: CatchCalibration,
          meta: {
            prefix_permission: 'calibration_catchs',
          },
        },
      ],
    },
    {
      path: 'reports',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'calibration.calibration',
          component: CalibrationReports,
          meta: {
            prefix_permission: 'calibration_reports',
          },
        },
      ],
    },
  ]
};

export default CalibrationRoutes;